import { forwardRef, useMemo } from "react";

import { Icons } from "widgets";

import { pluralizeWord } from "../../../../app-utils/string.js";
import { type Parent } from "../../../../graphql.js";
import { Tile, type TileProps } from "../../../../modules/core/components/Tile.js";
import { ENTITY_TYPE } from "../../../../settings/settings.js";

interface SampleParentTileProps extends Pick<TileProps, "footNote"> {
  parent: Parent;
}

const SampleParentTile = forwardRef<HTMLDivElement, SampleParentTileProps>(function SampleParentTile(props, ref) {
  /**
   * Add the number of samples in the types if available
   */
  const type = useMemo(() => {
    let type = props.parent?.parentType?.name || "Sample Parent";
    let count: number | undefined = Number(props.parent?.sampleCount);

    if (isNaN(count)) {
      count = props.parent.samples?.length;
    }

    if (count != undefined) {
      type = `${type} (${count} ${pluralizeWord("sample", count)})`;
    }

    return type;
  }, [props.parent]);

  if (!props.parent) return null;

  return (
    <Tile
      title={props.parent.name}
      type={type}
      to={`/${ENTITY_TYPE.SAMPLE_PARENT}/${props.parent.id}`}
      icon={<img src={Icons.Tiles.SampleParent} width={24} height={30} />}
      footNote={props.footNote}
      ref={ref}
    >
      {props.parent.description}
    </Tile>
  );
});

export { SampleParentTile };
